import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const AddCircle = ({
  fill = colors.silverSandAlt,
  size = 16,
  title = 'Add',
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 14.137 14.137">
      {Boolean(title) && <title>{title}</title>}
      <g transform="translate(-1433.738 -100.718)">
        <path
          d="M369.892,205.436h-2.233v-2.231a.4.4,0,0,0-.391-.412h-.02a.394.394,0,0,0-.352.412v2.231h-2.232a.411.411,0,1,0,0,.823H366.9v2.232a.411.411,0,0,0,.823,0h0v-2.232h2.231a.4.4,0,0,0,.412-.392v-.019A.5.5,0,0,0,369.892,205.436Z"
          transform="translate(1073.499 -98.061)"
          fill={fill}
          stroke={fill}
          strokeWidth="0.75"
        />
        <circle
          cx="6.269"
          cy="6.269"
          r="6.269"
          transform="translate(1434.538 101.518)"
          fill="none"
          stroke={fill}
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
};
